<template>
  <div class="flash-messages__message" :class="containerClass">
    <div class="flash-message__message-text">{{ theMessage.text }}</div>
    <div class="flash-message__dismiss">
      <button v-if="theMessage.dismissable" class="flash-message__button flash-message__button--close" @click.prevent="dismissMessage"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['message'],
    data() {
      return {
        theMessage: {
          text: '',
          dismissed: false,
          dismissable: true,
          dismissAfter: 5000,
          type: 'success',
        }
      };
    },
    computed: {
      containerClass() {
        return `flash-message--${this.theMessage.type || 'success'}`;
      },
    },
    methods: {
      dismissMessage() {
        this.$store.dispatch('flash/dismissMessage', this.message);
      },
    },
    mounted() {
      this.theMessage = { ...this.theMessage, ...this.message };
      if (this.theMessage.dismissAfter) {
        setTimeout(() => {
          this.$store.dispatch('flash/removeMessage', this.theMessage);
        }, this.theMessage.dismissAfter);
      }
    },
  }
</script>
